import { useLocation, Navigate } from "react-router-dom";
import { resolveRedirect, resolveQueryRedirect } from "../seo/redirects";
import { isBot } from "../lib/activeLang";

const SITE = "https://torri.solar";

// Segnala ai prerender/crawler un redirect permanente verso la nuova URL.
function markPermanentRedirect(to) {
  try {
    if (!isBot() || document.querySelector('meta[name="prerender-status-code"]')) return;
    const add = (name, content) => {
      const m = document.createElement("meta");
      m.setAttribute("name", name);
      m.setAttribute("content", content);
      document.head.appendChild(m);
    };
    add("prerender-status-code", "301");
    add("prerender-header", `Location: ${SITE}${to}`);
  } catch (e) { /* noop */ }
}

// Redirect vecchie->nuove URL lato client (fallback valido su qualsiasi hosting).
export default function RedirectHandler({ children }) {
  const { pathname, search } = useLocation();
  const queryTo = search ? resolveQueryRedirect(pathname, search) : null;
  const to = queryTo || resolveRedirect(pathname);
  if (to && (to !== pathname || queryTo)) {
    markPermanentRedirect(to);
    return <Navigate to={to} replace />;
  }
  return children;
}
